import {Pipe, PipeTransform} from '@angular/core';
import {add, endOfDay, isAfter, isBefore, parse, set, startOfDay} from 'date-fns';
import {TaskDto} from '../../../Models/Tasks/General/task.interface';

@Pipe({
  name: 'tasks',
  standalone: false
})
export class TasksPipe implements PipeTransform {

  transform(items: TaskDto[], filter: { menu: string; period?: number; }): TaskDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    const now: Date = new Date();

    if (filter.period) {
      items = items.filter((item) => item.id_periodo === filter.period);
    }

    if (filter.menu === 'all') {
      return items;
    }

    if (filter.menu === 'inProcess') {

      return items.filter((item) => {

        const itemDate: Date = parse(item.dia, 'yyyy-MM-dd', new Date());

        let itemStartDate: Date = startOfDay(itemDate);
        let itemEndDate: Date = endOfDay(itemDate);

        if (item.hora) {
          const [hours, minutes] = item.hora.split(':').map(Number);
          itemStartDate = set(itemDate, {hours, minutes});
        }

        if (item.hora_fin) {
          const [hours, minutes] = item.hora_fin.split(':').map(Number);
          itemEndDate = set(itemDate, {hours, minutes});
        }

        if (item.hora_fin_nexday) {
          itemEndDate = add(itemEndDate, {days: 1});
        }

        const isInProcess: boolean = isBefore(itemStartDate, now) && isAfter(itemEndDate, now);

        return isInProcess || item.persistente;

      });

    }

    return items;

  }

}
